import {Base} from "@/api/Base"

export class Logout extends Base {
    //此处修改后台用户登出的路径
    path = "employee/logout"
}